import { render, staticRenderFns } from "./ModalCreateNewPersonalizationSet.vue?vue&type=template&id=2baf660e&scoped=true"
import script from "./ModalCreateNewPersonalizationSet.vue?vue&type=script&lang=js"
export * from "./ModalCreateNewPersonalizationSet.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateNewPersonalizationSet.vue?vue&type=style&index=0&id=2baf660e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baf660e",
  null
  
)

export default component.exports